import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';

import Button from '../../../../../../../../../../atoms/Button';

interface SubmitProps {
  className?: string;
  disabled?: boolean;
}

const Submit: FC<SubmitProps> = ({ className, disabled }) => (
  <Button ariaLabel="Search" className={className} disabled={disabled} type="submit">
    <FontAwesomeIcon icon={faMagnifyingGlass} />
  </Button>
);

export default Submit;
